import React from 'react';
import './style.css';

const Content = () => (
  <section className="workshop-content-parent-container">
    <div className="workshop-content-child-container">
      <div className="workshop-content-child-left">
        <p className="workshop-content-text">
          These workshops are a 2-3 days of hands-on as well as mental exercise
          on the topics you choose and are aimed to be seen as catalyst to your
          career in the given topic.
        </p>
        {/* <p className="workshop-content-text">
          With some of the key fundamentals covered, it will be followed by a
          test that would grant the top ranker a paid 1 month internship, and
          the next 4 rankers an unpaid internship at our organization, where the
          students can get a further live hands on experience on real time
          products.
        </p> */}
        <p className="workshop-content-text">
          It's an exciting opportunity, with a lot to gain and it would involve
          some good discussion rounds with like minded people.
        </p>
        <p className="workshop-content-text bold-blue">
          Join and grab a chance to grow!
        </p>
      </div>
    </div>
  </section>
);

export default Content;



// WEBPACK FOOTER //
// ./src/Pages/Workshop/Content.js